import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import FallbackImage from 'assets/icons/fallback_image.svg';

export const ArticleLazyImage = ({ src, alt }) => {
  const [errored, setErrored] = useState(false);

  return (
    <>
      {errored ? (
        <img
          src={FallbackImage}
          alt={alt}
          style={{ objectFit: 'initial', width: '26px' }}
        />
      ) : (
        <LazyLoadImage
          src={src}
          alt={alt}
          onError={() => setErrored(true)}
        />
      )}
    </>
  );
};

ArticleLazyImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};
